type MetaTrackingIds = {
  fbp: string | null;
  fbc: string | null;
};

const getCookieValue = (name: string): string | null => {
  if (!process.client || !document.cookie) return null;
  const escapedName = name.replace(/([.*+?^${}()|[\]\\])/g, "\\$1");
  const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const useMetaTrackingIds = (): MetaTrackingIds => {
  if (!process.client) {
    return { fbp: null, fbc: null };
  }

  const fbp = getCookieValue("_fbp");
  let fbc = getCookieValue("_fbc");

  if (!fbc) {
    const fbclid = new URL(window.location.href).searchParams.get("fbclid");
    if (fbclid) {
      fbc = `fb.1.${Date.now()}.${fbclid}`;
    }
  }

  return {
    fbp: fbp || null,
    fbc: fbc || null,
  };
};
